import React, { Component } from 'react';
import { connect } from 'react-redux';
import LANGUAGES_CONTROLLER from '../../controllers/languages';
import FILES_CONTROLLER from '../../controllers/files';
import DOCUMENTS_CONTROLLER from '../../controllers/documents';
import UploadPanel from './UploadPanel';
import LanguageStringResolver from '../fields/language/LanguageStringResolver';
import UnprocessedFilesPanel from './UnprocessedFiles/Panel';
import AppConfig from '../../utils/appConfig';
import Logger, {LOG_LEVELS, ALL_MESSAGES} from '../../utils/logger';
import ApplicationMessages from '../inAppMessages/ApplicationMessages';
import getClientConfig from '../../utils/getClientConfig';
import { DateHelper } from '../../utils/helpers';
const log = new Logger('UPLOAD_PAGE', LOG_LEVELS.DEBUG);

const MaxFileSizeInMB =  Number.isInteger(AppConfig.UploadConfig.maxFileSize)  ?  AppConfig.UploadConfig.maxFileSize / AppConfig.UploadConfig.bytesPerKB : Infinity;

class Upload extends Component {
  render() {
    log.debug('render(): ', this.props);
    // The documents in the uploadedDocuments list are removed as soon as they are processed.
    // So they are effectively the list of unprocessedDocuments.
    const unprocessedDocuments = this.props.uploadedDocuments;
    const transactionFileTypes = this.props.transactionFileTypes || [];
    const enableClearingText = getClientConfig()?.featureFlags?.EnableClearingText;
    log.debug('transactionFileTypes: ', transactionFileTypes);
    // TODO: make this configurable
    const numberOfFilesToUpload = 1;
    // TODO: this will have to change when numberOfFilesToUpload increases from 1.
    let files = [];
    if (this.props.files && this.props.files.upload) {
      files.push(this.props.files.upload)
    }
    return (
      <div data-testid="file-upload" className="content-area" data-test="component-import-transaction-page">
        <s-container class="mb50">
          <ApplicationMessages messageType="applicationError" 
                  messageIds={[ALL_MESSAGES.VIRUS_SCAN_FAILED,
                    ALL_MESSAGES.DUPLICATE_FILE,
                    ALL_MESSAGES.FILE_IMPORT_ERROR_EXTENSION_FORBIDDEN,
                    ALL_MESSAGES.FILE_IMPORT_ERROR_EXTENSION_TOO_LONG,
                    ALL_MESSAGES.FILE_IMPORT_ERROR_FILENAME_TOO_LONG,
                    ALL_MESSAGES.FILE_IMPORT_ERROR_FILENAME_FORBIDDEN,
                    ALL_MESSAGES.FILE_IMPORT_ERROR_CONTENTTYPE_FORBIDDEN,
                    ALL_MESSAGES.FILE_IMPORT_ERROR_CONTENTTYPE_MISMATCH]}
                  />
          <h1 className="mb20"><LanguageStringResolver string='TitleImportTransactions'/></h1>
          <s-row>
            <s-col span="6">
              <UploadPanel uploadLimit={numberOfFilesToUpload}
                            acceptTypes={enableClearingText ? transactionFileTypes : transactionFileTypes.filter(fileType => fileType !== ".clearingtxt")}
                            onUploadRequest={this.onUploadRequest.bind(this)}
              />
            </s-col>
            <s-col span="6">
              <s-box class="mb20">
                <h2><LanguageStringResolver string='uploadInformation'/></h2>
                  <p><LanguageStringResolver string='acceptedFormats'/><br />
                  <span className="accepted-file-types">
                    {(enableClearingText ? transactionFileTypes : transactionFileTypes.filter(fileType => fileType !== ".clearingtxt")).map((fileType, index) => {
                      return (
                          <span
                            key={index}
                            className="semi-bold"
                          >
                            <LanguageStringResolver string={fileType}/>
                          </span>
                      )
                    })}
                    </span>
                  </p>

                  {
                    Number.isFinite(MaxFileSizeInMB) ? 
                     (
                      <p>
                        <LanguageStringResolver string='maxFileSize'/>:<br /> 
                        <span>
                          {`${MaxFileSizeInMB} MB`}
                        </span>
                      </p>
                     ): (
                      <span></span>     
                     )
                  }
                  <p><LanguageStringResolver string='fileNameRestrictionsTitle'/><br />
                  <LanguageStringResolver string='fileNameRestrictions'/> <br />
                  <code><LanguageStringResolver string='fileNameAllowedSpecialCharacters'/></code></p>
                  <p><LanguageStringResolver string='rightToUse'/></p>
              </s-box>
              <s-box>
                <h2><LanguageStringResolver string='downloadGenericFullTemplateTitle'/></h2>
                <div className="p10 pt0">
                  <p><LanguageStringResolver string='downloadGenericFullTemplateText'/></p>
                  <a data-test="button-download-full-template" className="button secondary mb10" href="/full-template.xls"><LanguageStringResolver string='downloadGenericFullTemplateBtn'/></a>
                  <a data-test="button-download-gl-template" className="button secondary mb10" href="/gldata-template.xls"><LanguageStringResolver string='downloadGenericGLTemplateBtn'/></a>
                  {enableClearingText && <a data-test="button-download-ct-template" className="button secondary mb10" href="/clearing-template.xls"><LanguageStringResolver string='downloadGenericCTTemplateBtn' /></a>}
                </div>
              </s-box>
            </s-col>
          </s-row>
          <UnprocessedFilesPanel documents={unprocessedDocuments} onRefreshRequest={this.refreshUnprocessedFileList.bind(this)}/>
        </s-container>
      </div>
    );
  }

  componentDidMount() {
    log.debug('componentDidMount()');
    log.clearAllDictionaryErrors();
  }
    componentWillUnmount() {
        log.debug('componentWillUnmount(): ');
        log.clearDictionaryError(ALL_MESSAGES.DUPLICATE_FILE);
        log.clearDictionaryError(ALL_MESSAGES.LARGE_FILE);
    }
  refreshUnprocessedFileList() {
    log.debug('refreshUnprocessedFileList(): ');

    // Start date of the current month
    const startDate = DateHelper.getStartDateOfCurrentMonth();

    // End date of the current month
    const endDate =  DateHelper.getEndDateOfCurrentMonth();

    this.props.doRefreshDocumentList({ companyId: "All", startDate: startDate, endDate: endDate })
  }

  onUploadRequest(filesToBeSent) {
    log.debug('onUploadRequest(): ', filesToBeSent);
    if(filesToBeSent.length <= 0){
      alert("Please upload some files first");
      return;
    }
    // TODO: this will have to change when we increase the numberOfFilesToUpload from 1
    this.props.doUploadFile(filesToBeSent[0]);
  }
}


// Which props do we want to inject, given the global state?
function mapStateToProps(state) {
  log.debug('mapStateToProps: ', state);

  return {
    languages: state.languages,
    transactionFileTypes: state.content && state.content.data && state.content.data.transactionFileTypes,
    files: state.files,
    uploadedDocuments: state.documents && state.documents.uploadedFiles
  };
}

function mapDispatchersToProps(dispatch) {
  return {
    doUploadFile: (file) => {
      log.debug('doUploadFile: ', file);
        log.clearDictionaryError(ALL_MESSAGES.DUPLICATE_FILE);
        log.clearDictionaryError(ALL_MESSAGES.LARGE_FILE);
        log.clearDictionaryError(ALL_MESSAGES.VIRUS_SCAN_FAILED);
        log.clearDictionaryError(ALL_MESSAGES.UNABLE_TO_PROCESS_FILE);
        log.clearDictionaryError(ALL_MESSAGES.FILE_IMPORT_ERROR_EXTENSION_FORBIDDEN);
        log.clearDictionaryError(ALL_MESSAGES.FILE_IMPORT_ERROR_EXTENSION_TOO_LONG);
        log.clearDictionaryError(ALL_MESSAGES.FILE_IMPORT_ERROR_FILENAME_TOO_LONG);
        log.clearDictionaryError(ALL_MESSAGES.FILE_IMPORT_ERROR_FILENAME_FORBIDDEN);
        log.clearDictionaryError(ALL_MESSAGES.FILE_IMPORT_ERROR_CONTENTTYPE_FORBIDDEN);
        log.clearDictionaryError(ALL_MESSAGES.FILE_IMPORT_ERROR_CONTENTTYPE_MISMATCH);

        dispatch(FILES_CONTROLLER.doUploadFile(file));
    },
    doRefreshDocumentList: (apiParams) => {
      log.debug('doRefreshDocumentList(): ');
      dispatch(DOCUMENTS_CONTROLLER.doLoad(apiParams));
    }
  }
}

// Wrap the component to inject dispatch and state into it
export default connect(mapStateToProps, mapDispatchersToProps)(Upload);